var map = {
	"./add.svg": 14939,
	"./annual-leave-tree.svg": 62850,
	"./annual-leave.svg": 94465,
	"./apply-leave.svg": 84808,
	"./arrow-bottom.svg": 58431,
	"./arrow-left-right.svg": 79216,
	"./arrow-right.svg": 25076,
	"./asset-add.svg": 25344,
	"./asset-amount.svg": 43759,
	"./asset-assigned.svg": 6795,
	"./asset-available.svg": 76612,
	"./asset-outline.svg": 55539,
	"./asset-pending.svg": 18512,
	"./asset-total.svg": 70707,
	"./asset.svg": 54698,
	"./attendance-outline.svg": 4134,
	"./attendance.svg": 62275,
	"./back-arrow-icon.svg": 26619,
	"./backtotop-icon.svg": 92453,
	"./birthday-square.svg": 64195,
	"./birthday.svg": 35281,
	"./calendar-info.svg": 77765,
	"./calendar-outline.svg": 42117,
	"./calendar.svg": 83676,
	"./cancel.svg": 87976,
	"./card-outline.svg": 16289,
	"./card.svg": 14704,
	"./carry-forward.svg": 36307,
	"./circle-tick.svg": 2700,
	"./claim-status-approved.svg": 14015,
	"./claim-status-pending.svg": 13655,
	"./claim-status-rejected.svg": 81016,
	"./close-circle-green.svg": 34905,
	"./close-circle.svg": 5583,
	"./cloud-upload.svg": 51241,
	"./create-workdaygroup.svg": 51963,
	"./currency-outline.svg": 30566,
	"./currency.svg": 96387,
	"./dashboard-overview.svg": 44070,
	"./dashboard-task-circle.svg": 91657,
	"./dashboard-task.svg": 31260,
	"./dashboard-unpaid-leave-circle.svg": 52739,
	"./dashboard-unpaid-leave.svg": 74342,
	"./date-picker-dropdown-arrow.svg": 99781,
	"./date-picker-prefix.svg": 42914,
	"./document-export.svg": 30212,
	"./document-icon.svg": 33177,
	"./document-locked.svg": 95888,
	"./document.svg": 27637,
	"./download.svg": 15398,
	"./dropdown-arrow.svg": 98733,
	"./edit.svg": 82226,
	"./email-invitation.svg": 64662,
	"./email-placeholder-prefix.svg": 65879,
	"./employee-outline.svg": 58891,
	"./employee.svg": 78258,
	"./empty-page.svg": 4711,
	"./error-page-404.svg": 30159,
	"./error-page-500.svg": 76090,
	"./error-page.svg": 10232,
	"./event-clock.svg": 10251,
	"./event-square.svg": 19470,
	"./event.svg": 8370,
	"./expandable-icon.svg": 6648,
	"./export-linear.svg": 22622,
	"./export.svg": 38808,
	"./file-lock.svg": 91244,
	"./filter-action.svg": 8691,
	"./filter-asset-type.svg": 12152,
	"./filter-claim-type.svg": 77888,
	"./filter-date-range.svg": 67537,
	"./filter-date.svg": 35389,
	"./filter-department.svg": 38767,
	"./filter-job-title.svg": 82875,
	"./filter-leave-type.svg": 27867,
	"./filter-status.svg": 96775,
	"./filter-year.svg": 99018,
	"./filter.svg": 57236,
	"./help-outline.svg": 71714,
	"./help.svg": 1079,
	"./holiday-square.svg": 88358,
	"./holiday.svg": 72490,
	"./home-outline.svg": 48154,
	"./home.svg": 40991,
	"./info-circle-outline.svg": 57390,
	"./leave-square.svg": 53233,
	"./leave.svg": 77291,
	"./link-icon.svg": 26920,
	"./link.svg": 63534,
	"./location-tick.svg": 73691,
	"./logo.svg": 82471,
	"./logout.svg": 28692,
	"./medical-leave-2.svg": 53528,
	"./medical-leave.svg": 46353,
	"./modal-close-button.svg": 84095,
	"./more.svg": 30497,
	"./noasset-icon.svg": 94281,
	"./notification-bing.svg": 96882,
	"./notification-email.svg": 79076,
	"./notification-push.svg": 88120,
	"./notification.svg": 48419,
	"./overtime.svg": 74859,
	"./paid-feature-icon-hover.svg": 48032,
	"./paid-feature-icon.svg": 32741,
	"./partyhat.svg": 82541,
	"./password-placeholder-prefix.svg": 47186,
	"./performance-good.svg": 50446,
	"./performance-moderate.svg": 57466,
	"./performance-under.svg": 5317,
	"./public-holiday.svg": 44938,
	"./read-all.svg": 58636,
	"./receipt-add.svg": 96188,
	"./receipt-edit.svg": 243,
	"./replacement.svg": 38066,
	"./save.svg": 72885,
	"./search-normal.svg": 57750,
	"./settings-outline.svg": 98136,
	"./settings.svg": 48365,
	"./speaker-outline.svg": 64596,
	"./speaker.svg": 62273,
	"./stickynote-outline.svg": 45110,
	"./stickynote.svg": 11635,
	"./task-2.svg": 90740,
	"./task-bag.svg": 55240,
	"./task-square.svg": 57623,
	"./task.svg": 50181,
	"./tick.svg": 1517,
	"./trash-outline.svg": 22001,
	"./undo.svg": 15176,
	"./unpaid-leave.svg": 46507,
	"./user-add.svg": 65841,
	"./user-import.svg": 84711,
	"./user-invite.svg": 64979,
	"./user-transfer.svg": 89361,
	"./user.svg": 19095,
	"./vuesax-bold-clipboard-text.svg": 34005,
	"./vuesax-bold-document-text.svg": 91064,
	"./vuesax-bold-folder.svg": 54651,
	"./vuesax-bold-timer.svg": 65370,
	"./vuesax-linear-chart-2.svg": 89886,
	"./vuesax-linear-close-circle.svg": 2724,
	"./vuesax-linear-document-previous.svg": 63312,
	"./vuesax-linear-element.svg": 45555,
	"./vuesax-linear-people.svg": 42540,
	"./vuesax-linear-row-vertical.svg": 3102,
	"./vuesax-linear-user-tick.svg": 97918,
	"./vuesax-linear-user.svg": 72452,
	"./vuesax-outline-trend-up.svg": 54993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22050;